export default "__VITE_ASSET__DWTDOYWl__"